import {
	FETCH_ENTITES_BEGIN,
	FETCH_ENTITES_SUCCESS,
	FETCH_ENTITES_ERROR,
	POST_ENTITE_RESET,
	POST_ENTITE_SUCCESS,
	POST_ENTITE_ERROR,
	POST_ENTITE_BEGIN,
	UPDATE_ENTITE,
	SET_ENTITES_LIST_UI,
	DELETE_FILE_VEHICULE_RESET,
	DELETE_FILE_VEHICULE_BEGIN,
	DELETE_FILE_VEHICULE_SUCCESS,
	DELETE_FILE_VEHICULE_ERROR,
	DELETE_CARTE_GRISE_ERROR,
	DELETE_CARTE_GRISE_RESET,
	DELETE_CARTE_GRISE_BEGIN,
	DELETE_CARTE_GRISE_SUCCESS,
	DELETE_VEHICULE_BEGIN,
	DELETE_VEHICULE_RESET,
	DELETE_VEHICULE_SUCCESS,
	DELETE_VEHICULE_ERROR,
	DELETE_ENTITE_BEGIN,
	DELETE_ENTITE_ERROR,
	DELETE_ENTITE_SUCCESS,
	DELETE_ENTITE_RESET,
} from "../actions/entiteActions"
import { getBaseEntite } from "../../utilities/defaultObjects"

const initialState = {
	entites: [],
	editEntite: getBaseEntite(),
	// État UI persistant de la liste /clients (recherche, filtre, offset page).
	listUi: {
		search: "",
		typeFilter: "all",
		offset: 0,
	},
	entitesPagination: {
		first: null,
		previous: null,
		current: null,
		next: null,
		last: null,
	},
	fetchEntites: {
		loading: false,
		error: false,
	},
	postEntite: {
		saving: false,
		saved: false,
		error: false,
	},
	deleteEntite: {
		deleting: false,
		deleted: false,
		error: false,
	},
	deleteVehicule: {
		deleting: false,
		deleted: false,
		error: false,
	},
}

export default function entiteReducer(state = initialState, action) {
	switch (action.type) {
		case DELETE_ENTITE_BEGIN:
			return {
				...state,
				deleteEntite: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ENTITE_ERROR:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}

		case DELETE_ENTITE_SUCCESS:
			let entiteIndex = state.entites.findIndex(
				(e) => e.id === action.payload.id,
			)
			if (entiteIndex !== -1) {
				return {
					...state,
					entites: [
						...state.entites.slice(0, entiteIndex),
						...state.entites.slice(entiteIndex + 1),
					],
					deleteEntite: {
						deleting: false,
						deleted: true,
						error: false,
					},
				}
			}
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_ENTITE_RESET:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_VEHICULE_BEGIN:
			return {
				...state,
				deleteVehicule: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_VEHICULE_RESET:
			return {
				...state,
				deleteVehicule: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_VEHICULE_SUCCESS:
			let foundIndex = state.entites.findIndex(
				(ent) => ent.id === action.payload.id,
			)
			if (foundIndex !== -1) {
				return {
					...state,
					entites: [
						...state.entites.slice(0, foundIndex),
						action.payload,
						...state.entites.slice(foundIndex + 1),
					],
					deleteVehicule: {
						deleting: false,
						deleted: true,
						error: false,
					},
				}
			}
			return { ...state }
		case DELETE_VEHICULE_ERROR:
			return {
				...state,
				deleteVehicule: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case DELETE_CARTE_GRISE_RESET:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_CARTE_GRISE_BEGIN:
			return {
				...state,
				deleteEntite: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_CARTE_GRISE_SUCCESS:
			return {
				...state,
				editEntite: action.payload,
				deleteEntite: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_CARTE_GRISE_ERROR:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case DELETE_FILE_VEHICULE_RESET:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: false,
				},
			}
		case DELETE_FILE_VEHICULE_BEGIN:
			return {
				...state,
				deleteEntite: {
					deleting: true,
					deleted: false,
					error: false,
				},
			}
		case DELETE_FILE_VEHICULE_SUCCESS:
			return {
				...state,
				editEntite: action.payload,
				deleteEntite: {
					deleting: false,
					deleted: true,
					error: false,
				},
			}
		case DELETE_FILE_VEHICULE_ERROR:
			return {
				...state,
				deleteEntite: {
					deleting: false,
					deleted: false,
					error: action.payload,
				},
			}
		case UPDATE_ENTITE:
			return {
				...state,
				editEntite: action.payload,
			}
		case SET_ENTITES_LIST_UI:
			return {
				...state,
				listUi: { ...state.listUi, ...action.payload },
			}
		case FETCH_ENTITES_BEGIN:
			return {
				...state,
				fetchEntites: {
					loading: true,
					error: false,
				},
			}
		case FETCH_ENTITES_SUCCESS:
			return {
				...state,
				entites: action.payload.entites,
				entitesPagination: action.payload.pagination,
				fetchEntites: {
					loading: false,
					error: false,
				},
			}
		case FETCH_ENTITES_ERROR:
			return {
				...state,
				fetchEntites: {
					loading: false,
					error: action.payload.error,
				},
			}
		case POST_ENTITE_BEGIN:
			return {
				...state,
				postEntite: {
					saving: true,
					saved: false,
					error: false,
				},
			}
		case POST_ENTITE_RESET:
			return {
				...state,
				postEntite: {
					saving: false,
					saved: false,
					error: false,
				},
			}
		case POST_ENTITE_ERROR:
			return {
				...state,
				postEntite: {
					saving: true,
					saved: false,
					error: action.payload,
				},
			}
		case POST_ENTITE_SUCCESS:
			return {
				...state,
				editEntite: action.payload,
				postEntite: {
					saving: false,
					saved: true,
					error: false,
				},
			}
		default:
			return state
	}
}
